exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-table-row[data-v-069a4107]{padding:6px 0;border-bottom:1px solid #989898}", ""]);

// exports
